import { cpfValidator } from 'helpers/cpfValidator';
import { Dispatch, SetStateAction, useState } from 'react';
import { User } from 'types/user';
import * as yup from 'yup';

export type AccountValidation = {
  document_number?: string;
  rg?: string;
  name?: string;
};

type UseAccountValidation = [
  AccountValidation,
  Dispatch<SetStateAction<AccountValidation>>,
  (user: User) => Promise<void>,
];

export function useAccountValidation(): UseAccountValidation {
  async function handleValidation(user: User) {
    const schema = yup.object().shape({
      document_number: yup
        .string()
        .required('CPF é obrigatório')
        .transform((value, originalValue) => {
          return originalValue ? originalValue.replace(/\D/g, '') : '';
        })
        .test('docValidation', `CPF inválido`, value => {
          if (!value) return false;

          const cpf = cpfValidator(value);

          return cpf;
        }),
      rg: yup.string().required('RG é obrigatório'),
      name: yup.string().required('O nome é obrigatório').min(10, 'O nome deve ter no mínimo 10 caracteres'),
    });

    try {
      await schema.validate(user);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<AccountValidation>({});
  return [validation, setValidation, handleValidation];
}
